import React, { Component } from 'react';
import ScheduleDefault from 'components/schedule-default';
import Logout from 'components/logout';
import './settings.css';

class Settings extends Component {
  render() {
    return (
      <div className="settings">
        <div className="logout-section">
          <Logout />
        </div>
      </div>
    );
  }
}

export default Settings;



// WEBPACK FOOTER //
// ./src/components/settings/index.js